import { Grid } from '@change/ds-layout/next';

import { Container } from '@change-corgi/design-system-legacy/layout';

import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { PageFooter } from '../components/PageFooter';
import { PageHeading } from '../components/PageHeading';
import { PageMembershipAwareness } from '../components/PageMembershipAwareness';
import { PageMeta } from '../components/PageMeta';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();
	return (
		<Grid className="px-0">
			<PageBanner />
			<Container className="col-span-full" mt={16}>
				<PageMeta />
				<PageHeading px={[16, 8]} />
				<PageBody mt={32} mb={16} px={[16, 8]} />
			</Container>
			<div className="col-span-full">
				<PageMembershipAwareness />
			</div>
			<PageFooter className="col-span-full" pb={32} />
		</Grid>
	);
};
